import {
  SAVED_FILTERS_GET_ALL_ENDPOINT,
  SAVED_FILTERS_GET_ONE_ENDPOINT,
  SAVED_FILTERS_SAVE_NEW_ENDPOINT,
  SAVED_FILTERS_DELETE_ENDPOINT,
} from "../Constants/api-routes.constant";
import { GetAuthToken } from "./auth-verification.util";

/**
 * Get All Saved Filters of Customer
 * @returns
 */
export const GetAllSavedFilters = async () => {
  const authToken = GetAuthToken();
  if (!authToken) return [];

  return fetch(SAVED_FILTERS_GET_ALL_ENDPOINT, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => err);
};

/**
 * Get One by Hash
 * @returns
 */
export const GetOneSavedFilterByHash = async (filterHash) => {
  const authToken = GetAuthToken();
  if (!authToken) return [];

  return fetch(SAVED_FILTERS_GET_ONE_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      filterHash,
    }),
  })
    .then((res) => res.json())
    .catch((err) => err);
};

/**
 * Create a new filter
 * @param {*} filterName
 * @param {*} searchCriteria
 * @returns
 */
export const CreateNewSavedFilter = async (filterName, searchCriteria) => {
  const authToken = GetAuthToken();
  if (!authToken || Object.keys(searchCriteria).length == 0) return [];

  return fetch(SAVED_FILTERS_SAVE_NEW_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      filterName,
      searchCriteria,
    }),
  })
    .then((res) => res.json())
    .catch((err) => err);
};

export const DeleteOneSavedFilter = async (filterHash) => {
  const authToken = GetAuthToken();
  if (!authToken) return [];

  return fetch(SAVED_FILTERS_DELETE_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      filterHash,
    }),
  })
    .then((res) => res.json())
    .catch((err) => err);
};
